import React from 'react';
import { IGetDishRestaurantPortion } from 'types/index';
import { Portion } from './Portion';
import style from './Portions.module.scss';

interface IProps {
	data: IGetDishRestaurantPortion[];
	onClickInfo: (value: string) => void;
	onClickEdit: (value: string) => void;
	onClickDelete: (value: string) => void;
}

export const Portions: React.FC<IProps> = React.memo(({ data, onClickInfo, onClickEdit, onClickDelete }) => {
	return (
		<div className={style.container} data-test="Portions">
			<div className={style.portionsList}>
				{data.map((el) => (
					<Portion
						key={el.id}
						portion={el}
						onClickInfo={() => onClickInfo(el.id)}
						onClickEdit={() => onClickEdit(el.id)}
						onClickDelete={() => onClickDelete(el.id)}
					/>
				))}
			</div>
		</div>
	);
});
